import { apiInstance_ecom } from "@/app/api-config/axios-instance";
import ServiceBase from "../service/ServiceBase";

const ENDPOINTS = {
  GET: "/cart/getCartDetails",
  UPDATE: "/cart/updateCartDetails",
  ADD: "/cart/addToCart",
  CHECKOUT: "/order/createOrder",
  CREATE_PAYMENT: "order/createPayment",
  DELETE_CART: "cart/deleteCart",
};

class CartManagementService extends ServiceBase {
  getCartDetails() {
    return this._handleAPICall(ENDPOINTS.GET);
  }
  deleteCartItems() {
    return this._handleAPICall(ENDPOINTS.DELETE_CART, {}, "delete");
  }
  updateCartDetails(payload) {
    const { productId, quantity } = payload;
    return this._handleAPICall(
      ENDPOINTS.UPDATE,
      {
        product_id: productId,
        quantity,
      },
      "post",
      false,
      true
    );
  }

  async addCartDetails(payload) {
    const { productId, quantity, multiple = false } = payload;

    const cartItems = payload?.cartItems?.length > 0 ? payload?.cartItems : [];
    const params = multiple ? JSON.stringify(cartItems) : { product_id: productId, quantity };
    try {
      const response = await apiInstance_ecom.post(ENDPOINTS.ADD, params, {
        skipLoader: true,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      console.error("Something went wrong while adding the cart item");
    }
  }

  //createOrder(Checkout-api)
  cartCheckout(payload) {
    return this._handleAPICall(ENDPOINTS.CHECKOUT, payload, "post");
  }
  createPyament(payload) {
    return this._handleAPICall(ENDPOINTS.CREATE_PAYMENT, payload, "post");
  }
}

const cartService = new CartManagementService();
export default cartService;
